<template>
    <div class="card-container"
         :style="getBackground(cardInfo)"
    >
        <div class="card-content">
            <div class="card-top">
                <div class="card-title">
                    <span class="card-sign">￥</span>
                    <span class="card-price">{{cardInfo.balance}}</span>
                    <span v-if="cardInfo.open_data && !!cardInfo.open_data.wait_refresh_amount" class="card-text">待圈存 ￥{{cardInfo.open_data.wait_refresh_amount}}</span>
                    <span class="card-text">积分 {{cardInfo.integral || '无'}}</span>
                </div>
                <div class="card-info" v-if="cardInfo.open_data && cardInfo.open_data.customer_info && cardInfo.open_data.customer_info.license_plate && showLicense">{{cardInfo.open_data.customer_info.license_plate}}</div>
            </div>

            <div class="card-bottom">No.{{cardInfo.card_no}}</div>

            <div class="card-name" v-if="cardInfo.name || (cardInfo.open_data && cardInfo.open_data.is_master)">
                <span style="color: #f66;" v-if="cardInfo.open_data && cardInfo.open_data.is_master">[主]</span>{{cardInfo.name}}
            </div>
        </div>
        <div class="card-default" v-if="!!cardInfo.is_default">
            <van-icon name="star" color="#f2826a" size="20"/>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'CardDesign',
        props: {
            cardInfo: {
                type: Object,
                default: {}
            },
			showLicense: {
				type: Boolean,
				default: false
			}
        },
        data() {
            return {
                backgroundUrl: {
                    company: require('../../assets/images/Generalledgercard_bg.png'),
                    personal: require('../../assets/images/oilcard_bg.png'),
                    deafult: require('../../assets/images/oilcard_bg.png'),
                }
            }
        },
        methods: {
            getBackground(cardInfo) {
                if (!!cardInfo.background_image) {
                    return `backgroundImage: url(${cardInfo.background_image})`
                } else {
                    return this.backgroundUrl[cardInfo.belong_to] ? `backgroundImage: url(${this.backgroundUrl[cardInfo.belong_to]})` : `backgroundImage: url(${this.backgroundUrl.deafult})`
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card-container{
        position: relative;
        width: 290px;
        height: 160px;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 10px 10px;
        color: #ffffff;
        font-size: 18px;
        background-size:100% 100%;
        .card-content{
            height: 100%;
            display: flex;
            width: 100%;
            flex: 1;
            flex-direction: column;
            justify-content: space-between;
        }
		.card-info,
        .card-title,
        .card-bottom {
            text-shadow: 0 0 20px  rgba(0, 0, 0, 1);
        }
        .card-title{
            font-size: 36px;
            .card-sign{
                font-size: 22px;
            }
            .card-text {
                font-size: 14px;
                margin-left: 5px;
                display: inline-block;
            }
        }
        .card-bottom{
            text-align: right;
        }
        .card-info {
        }
        .card-default{
            position: absolute;
            top: 15px;
            right: 20px;
        }
        .card-name{
            position: absolute;
            left: 10px;
            bottom: 10px;
            font-size: 14px;
            background-color: rgba(0,0,0, 0.5);
            padding: 3px 5px;
            border-radius: 5px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/beilin/CardDesign.vue